export const table_titles = [
	{ name: "#", size: 10, order: "" },
	{ name: "Nombre", size: 10, order: "name" },
	{ name: "Campo", size: 10, order: "" },
	{ name: "Bodega", size: 10, order: "" },
	{ name: "Superficie Total", size: 10, order: "" },
	{ name: "Acción", size: 10, order: "" },
	{ name: "", size: 5, order: "" },
];

export const base_list = {
	page: 1,
	paginate: 10,
	order: "name",
	orderType: "desc",
};

export const base_element = {
	id: "",
	name: "",
	customer_id: "",
	estates_parents: [],
	estates: [],
	businessCenters: [],
};

export const customStyles = {
	menuPortal: (base) => ({
		...base,
		zIndex: 9999999,
	}),
	menu: (provided) => ({ ...provided, zIndex: 9999999 }),
};
